

















import {Component, Mixins} from 'vue-property-decorator';
import BaseLayout from '@/layouts/BaseLayout.vue';
import Breadcrumb from '@/models/Breadcrumb';
import {ResponsiveMixin} from '@/mixins/ResponsiveMixin';
import Overlay from '@/models/Overlay';
import Alert from '@/models/Alert';

@Component({
  components: {
    BaseLayout,
  }
})
export default class BasePageView extends Mixins(ResponsiveMixin) {
  protected breadcrumbs: Breadcrumb[] = [];
  protected overlay = new Overlay();
  protected alert = new Alert();
  protected actions = [];
}
